<template>
  <div v-if="revenues.length > 0" class="accordion mt-3">
    <div
      v-for="(revenue, index) in revenues"
      :key="index"
      class="accordion-item"
    >
      <h2
        class="accordion-header"
        :id="`revenuePanel${index}`"
        title="Clique para Expandir/Recolher"
      >
        <button
          type="button"
          class="accordion-button collapsed border-primary"
          data-bs-toggle="collapse"
          :data-bs-target="`#revenueBody${index}`"
          :aria-controls="`revenueBody${index}`"
          aria-expanded="false"
        >
          {{ revenue.historico ? revenue.historico : revenue.item }}
        </button>
      </h2>
      <div
        :id="`revenueBody${index}`"
        class="accordion-collapse collapse"
        :aria-labelledby="`revenuePanel${index}`"
      >
        <div class="accordion-body">
          <div class="row">
            <div class="col-12 col-md-6">
              <p><strong>Faturamento: </strong>{{ revenue.faturamento }}</p>
            </div>
            <div class="col-12 col-md-6">
              <p><strong>Fornecedor: </strong>{{ revenue.fornecedor }}</p>
            </div>
            <div class="col-12 col-md-6">
              <p>
                <strong>Data da Nota Fiscal: </strong>
                {{ dateTimeRmToDateBR(revenue.dataNf) }}
              </p>
            </div>
            <div class="col-12 col-md-6">
              <p>
                <strong>Data de Baixa: </strong>
                {{ dateTimeRmToDateBR(revenue.dataBaixa) }}
              </p>
            </div>
            <div class="col-12 col-md-6">
              <p>
                <strong>Data de Faturamento: </strong>
                {{ dateTimeRmToDateBR(revenue.dataNf) }}
              </p>
            </div>
            <div class="col-12 col-md-6">
              <p>
                <strong>Data de Vencimento: </strong>
                {{ dateTimeRmToDateBR(revenue.vencimento) }}
              </p>
            </div>
            <div class="col-12 col-md-6">
              <p><strong>Item: </strong> {{ revenue.item }}</p>
            </div>
            <div class="col-12 col-md-6">
              <p><strong>Referência: </strong> {{ revenue.ref }}</p>
            </div>
            <div class="col-12 col-md-6">
              <p><strong>Movimento: </strong> {{ revenue.movimento }}</p>
            </div>
            <div class="col-12 col-md-6">
              <p><strong>Tipo: </strong> {{ revenue.tipo }}</p>
            </div>
            <div class="col-12 col-md-6">
              <p>
                <strong>Status do Lançamento: </strong>
                {{ revenue.statusLan }}
              </p>
            </div>
            <div class="col-12 col-md-6">
              <p>
                <strong>Número da Nota Fiscal: </strong>
                {{ revenue.numeroNf }}
              </p>
            </div>
            <div class="col-12 col-md-6">
              <p>
                <strong>Valor de Nota Fiscal: </strong>
                {{ formatToCurrencyBr(revenue.valorNf) }}
              </p>
            </div>
            <div class="col-12">
              <p><strong>Histórico: </strong>{{ revenue.historico }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p v-else class="text-center mt-3 mb-0">
    Nenhum faturamento encontrado para este contrato
  </p>
</template>

<script>
import { formatToCurrencyBr } from '@/utils/currency'
import { dateTimeRmToDateBR } from '@/utils/date'

export default {
  name: 'RevenuesContract',

  props: {
    revenues: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      formatToCurrencyBr,
      dateTimeRmToDateBR,
    }
  },
}
</script>
